
import { ModuleWithProviders, NgModule } from "@angular/core";
import { provideSvgIcons } from '@ngneat/svg-icon';
import { appPageNotFoundIcon } from "../svg/page-not-found";
export const SPOOL_TEMPLATE_FULL_NAME = 'SpoolService.OperationObjects.Models.Operation';

@NgModule({
  imports: [
  ],
  declarations: [
  ],
  exports: [
  ],
  providers: [
    provideSvgIcons([appPageNotFoundIcon]),
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }

  static forChild(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
